import React, { Suspense, lazy } from 'react';
import { Switch, Route, useHistory, Redirect } from 'react-router-dom'; //useHistory
import { connect, useDispatch } from 'react-redux';

//Global Components & Actions Imports
import { getCurrentUser } from '../../redux/Users/usersSelectors';
import Header from '../Layout/Header'
import Footer from '../Layout/Footer'
import Preloader from '../Layout/Preloader'


//Main Pages Imports
const FAQs = lazy(() => import('../../pages/FAQs'));
const Home = lazy(() => import('../../pages/Home'));
const TermsOfUse = lazy(() => import('../../pages/Terms'));
const AboutUs = lazy(() => import('../../pages/AboutUs'));
const ContactUs = lazy(() => import('../../pages/ContactUs'));
const Services = lazy(() => import('../../pages/Services'));
const BusinessConsulting = lazy(() => import('../../pages/Services/BusinessConsulting'));
const ContentMarketing = lazy(() => import('../../pages/Services/ContentMarketing'));
const OnlineStore = lazy(() => import('../../pages/Services/OnlineStore'));
const WebDesign = lazy(() => import('../../pages/Services/WebDesign'));
const RequestConsulting = lazy(() => import('../../pages/Services/RequestConsulting'));
const PrivacyPolicy = lazy(() => import('../../pages/PrivacyPolicy'));
const Projects = lazy(() => import('../../pages/Projects'));
// const NotFound = lazy(() => import('../../pages/Errors/404'));


export function UnconnectedApp({ currentUser }) {


    //Consts
    const token = localStorage.getItem('token') || null;
    const dispatch = useDispatch();
    const {
        location: { pathname },
    } = useHistory();


    const renderApp = () => {

        return (
            <div className="page">

                <Header />

                <Switch>
                    {/*<Route exact path="/404" component={NotFound} /> */}
                    <Route path="/services" component={Services} />
                    <Route path="/business-consulting" component={BusinessConsulting} />
                    <Route path="/webdesign" component={WebDesign} />
                    <Route path="/online-store" component={OnlineStore} />
                    <Route path="/content-marketing" component={ContentMarketing} />
                    <Route path="/projects" component={Projects} />
                    <Route path="/request-consulting" component={RequestConsulting} />
                    <Route path="/faqs" component={FAQs} />
                    <Route path="/terms-of-use" component={TermsOfUse} />
                    <Route path="/privacy-policy" component={PrivacyPolicy} />
                    <Route path="/contact-us" component={ContactUs} />
                    <Route path="/about-us" component={AboutUs} />
                    <Route exact path="/" component={Home} />
                </Switch>

                <Footer />

            </div>
        );

    };

    return (

        <div className="app" data-test="component-app">
            <Suspense fallback={<div className="page"><Preloader /></div>}>{renderApp()}</Suspense>
        </div>

    );

}

const mapStateToProps = (state) => ({
    currentUser: getCurrentUser(state),
});

export default connect(mapStateToProps)(UnconnectedApp);